export default class IncorrectLayoutTypeError extends Error {
  constructor() {
    super('Layout must be an of FCWithChildren array type.');
    this.name = 'IncorrectLayoutTypeError';
  }
}
